import { ContextService } from '../../services/context_service';
import { Font, Image, Page, Text, View } from '@react-pdf/renderer';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';

interface DatenauswertungReportSitemapProps extends React.ClassAttributes<any> {
    isPdf?: boolean;
    pages: any[];
}

interface DatenauswertungReportSitemapState {
    pdfData: any;
}

export class DatenauswertungReportSitemap extends React.Component<DatenauswertungReportSitemapProps, DatenauswertungReportSitemapState> {

    constructor(props: any) {
        super(props);
        this.state = {
            pdfData: null
        };
        this.init();
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private curNode: number;
    private styles: any;
    private tree: any[];

    init(): void {
        let category: number = -1;
        let indexGroup: number = -1;
        this.tree = [];
        this.setStyles();

        (this.props.pages || []).forEach((item: any, index: number) => {
            const key: string = item.key || null;
            const prevItem: any = this.props.pages[index - 1] || {};
            const prevKey: string = index ? prevItem.key || null : null;
            const prevStandort: number = index ? (prevItem.standort || {}).tid : null;
            const prevSub: any = index ? prevItem.sub || null : null;
            const standort: number = (item.standort || {}).tid;
            const isStandort: boolean = typeof standort === 'number';
            const sub: any = item.sub || null;

            if (isStandort && standort !== prevStandort) {
                this.tree.push({
                    name: (item.standort || {}).name || null,
                    standort,
                    children: []
                });
                ++indexGroup;
            } else if (!isStandort && category === -1) {
                ++category;
                this.tree.push({
                    name: 'Allgemein',
                    category,
                    children: []
                });
                ++indexGroup;
            }

            if (isStandort && sub !== null && (prevSub === null || (prevSub !== null && key !== prevKey) || standort !== prevStandort)) {
                this.tree[indexGroup].children.push({
                    name: item.name || null,
                    standort,
                    key,
                    children: []
                });
            }

            if (isStandort && sub !== null) {
                const indexParent: number = this.tree[indexGroup].children.map((item2: any) => item2.key).indexOf(key);
                this.tree[indexGroup].children[indexParent].children.push({
                    name: (sub || {}).name,
                    standort,
                    key,
                    sub: (sub || {}).key,
                    ...(item.curPage && { curPage: item.curPage })
                });
            } else {
                this.tree[indexGroup].children.push({
                    name: item.name || null,
                    ...(isStandort ? { standort } : { category }),
                    key,
                    ...(item.curPage && { curPage: item.curPage })
                });
            }
        });
    }

    render(): JSX.Element | JSX.Element[] {
        if (!this.props.pages) {
            return null;
        }
        this.curNode = -1;

        if (this.props.isPdf) {
            return this.renderPdf();
        }

        return this.renderNodes(this.tree, 0);
    }

    renderHeader(): JSX.Element {
        // const header = require('../../img/logo_mittel2.png');
        const header = require('../../img/Logo.jpg');
        const headerUnternehmen = this.contextService.get('UNTERNEHMEN_LOGO_URL');
        const sectionId: string = typeof SectionStyle.curPrintSectionId === 'number'
            ? SectionStyle.getCurrentId(true)
            : SectionStyle.getCurrentId();
        const headerSection = sectionId ? require(`../../img/logo_section_${sectionId}.jpg`) : header;
        const { styles } = this;

        return (
            <View style={styles.header} fixed>
                <Text style={styles.headerText}>E-Tool</Text>
                <View style={{ ...styles.headerSubText2, display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                    <Text style={{ fontFamily: 'Calibri-Bold', lineHeight: 1.05 }}>
                        →&nbsp;
                    </Text>
                    <Text>Inhaltsverzeichnis</Text>
                </View>
                {headerUnternehmen &&
                    <Image src={headerUnternehmen} style={styles.headerImageUnternehmen} />
                }
                <Image src={headerSection} style={styles.headerImage} />
            </View>
        );
    }

    renderFooter(): JSX.Element {
        const { styles } = this;

        return (
            <View style={styles.footer} fixed>
                <Text>{Moment().format('DD.MM.YYYY')}</Text>
                <View style={styles.footerPages}>
                    <Text
                        render={({ pageNumber, totalPages }) => {
                            if (totalPages > 1) {
                                return `${pageNumber}/${totalPages}`;
                            }
                        }}
                        fixed
                    />
                </View>
            </View>
        );
    }

    renderNode(item: any, level: number, index: number): JSX.Element {
        const { isPdf } = this.props;
        const { styles } = this;
        // console.log('Node', item);
        return (
            <WpdfView
                style={{ ...styles.node, ...styles[`level${level}`], paddingLeft: level * 10 + (level ? 0 : 10) }}
                pdf={isPdf}
            >
                {!!level &&
                    <WpdfView style={styles.number} pdf={isPdf}>
                        <WpdfText style={{ margin: 'auto', marginRight: 0 }} pdf={isPdf}>{`${index + 1}.`}</WpdfText>
                    </WpdfView>
                }
                <WpdfText pdf={isPdf}>{item.name}</WpdfText>
                {item.curPage &&
                    <WpdfView style={{ flex: 1 }} pdf={isPdf}>
                        <WpdfText style={{ margin: 'auto', marginRight: 0 }} pdf={isPdf}>{item.curPage}</WpdfText>
                    </WpdfView>
                }
            </WpdfView>
        );
    }

    renderNodes(data: any[], level: number): JSX.Element[] {
        return data.map((item: any, index: number) => {
            ++this.curNode;

            if (level === 0) {
                return (
                    <WpdfView key={`node-${this.curNode}`} pdf={this.props.isPdf}>
                        {this.renderNode(item, level, index)}
                        {item.children && item.children.length > 0 && this.renderNodes(item.children, level + 1)}
                    </WpdfView>
                );
            }

            return (
                <React.Fragment key={`node-${this.curNode}`}>
                    {this.renderNode(item, level, index)}
                    {item.children && item.children.length > 0 && this.renderNodes(item.children, level + 1)}
                </React.Fragment>
            );
        });
    }

    renderPdf(): JSX.Element {
        Font.register({ family: 'Calibri-Bold', src: require('../../font/calibri_regular.ttf') });

        return (
            <Page size='A4' orientation='portrait' style={this.styles.page}>
                {this.renderHeader()}
                {this.renderNodes(this.tree, 0)}
                {this.renderFooter()}
            </Page>
        );
    }

    setStyles(): void {
        const { isPdf } = this.props;
        const colorDatenauswertung: string = (SectionStyle.getSectionColors() || {}).datenauswertung;

        this.styles = {
            header: {
                fontSize: '18pt',
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                color: '#555',
                width: '100%',
                height: 60,
                top: 0,
                left: 0,
                padding: 0,
                position: 'relative',
                display: 'block'
            },
            headerImage: {
                width: 'auto',
                // width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            headerImageUnternehmen: {
                maxWidth: 80,
                height: 40,
                objectFit: 'contain',
                top: 0,
                right: 70,
                position: 'absolute'
            },
            headerText: {
            },
            headerSubText: {
                fontSize: '16pt',
                maxWidth: 500,
                color: colorDatenauswertung || '#5e8bc2'
            },
            headerSubText2: {
                fontSize: '11pt',
                color: '#555',
                marginTop: 10
            },
            headerSubText3: {
                fontSize: '10pt',
                color: colorDatenauswertung || '#6692c2'
            },
            footer: {
                fontSize: '8pt',
                right: 40,
                bottom: 15,
                left: 40,
                width: '100%',
                height: 'auto',
                padding: 0,
                position: 'absolute',
                display: 'block',
                boxSizing: 'border-box'
            },
            footerPages: {
                right: 0,
                position: 'absolute'
            },
            level0: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontWeight: 'bold',
                backgroundColor: '#bccae3',
                marginTop: 20
            },
            level2: {
                fontStyle: 'italic'
            },
            node: {
                padding: 1,
                paddingRight: 10,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            },
            number: {
                minWidth: 18,
                marginRight: 3,
                display: 'inline-flex'
            },
            page: {
                fontFamily: 'Helvetica',
                fontSize: '9pt',
                padding: 40,
                paddingTop: 20,
                paddingBottom: 25
            }
        };
    }
}
